import React, { useEffect, useState } from 'react';
import { Modal, Button } from 'react-bootstrap';
import { jsPDF } from 'jspdf';
import autoTable from 'jspdf-autotable';
import { useSelector } from 'react-redux';
import { addFooter, addHeader, addTitles, addWatermark } from './TemplatePrintModals';

const CajaDiariaPdf = ({ show, handleClose, title1, title2, title3,title4,title5, total1, total2, content, copia }) => {
    const [pdfUrl, setPdfUrl] = useState(null);
    const { nombre, usuario,rolActivo, roles,id } = useSelector(state => state.sesion);

    useEffect(() => {
        if (show) {
            generatePdf();
        }
    }, [show, content]);

    const generatePdf = () => {
        const doc = new jsPDF('p', 'pt', 'letter'); // Establecer tamaño de hoja a carta

        const marginLeftRight = 45; // Márgenes izquierdo y derecho
        const marginTop = 15; // Margen superior
        const marginBottom = 75; // Ajustar el margen inferior para bajar el pie de página
        const headerHeight = 50;

        // Validaciones: Asegurar que los valores no sean null o undefined
        const validTitle1 = title1 || '';
        const validTitle2 = title2 || '';
        const validTitle3 = title3 || '';
        const validTitle4 = title4 || '';
        const validTitle5 = title5 || '';
        const validTotal1 = total1 || '';
        const validTotal2 = total2 || '';
        

        // Inicializa el número de página
        let pageNumber = 0;

        const addTotals = (doc) => {
            const startY = doc.autoTable.previous.finalY + 25;
            doc.setFontSize(12);
            doc.setFont("times", "bold");
            doc.setTextColor(0, 0, 0); // Asegurar que los totales estén en negro
            if (validTotal1) {
                doc.text(validTotal1, marginLeftRight, startY);
            }
            if (validTotal2) {
                doc.text(validTotal2, marginLeftRight, startY + 15);
            }
        };

        // Draw watermark on the first page before any content if copia is true
        if (copia) {
            addWatermark(doc);
        }

        const titles = {validTitle1, validTitle2, validTitle3, validTitle4, validTitle5};
        const margins = {marginLeftRight, marginTop, marginBottom};
        if (typeof content === 'string') {
            addHeader({doc, pageNumber, headerHeight, marginLeftRight,marginTop});
            addTitles({doc, titles, margins, headerHeight});
            doc.text(content, marginLeftRight, marginTop + headerHeight + 125);
            addTotals(doc);
            addFooter({doc,marginLeftRight, marginBottom,nombre});
        } else {
            addHeader({doc, pageNumber, headerHeight, marginLeftRight,marginTop});
            const startY = addTitles({doc, titles, margins, headerHeight});
            const secondLastColumnWidth = doc.getTextWidth(content.body[content.body.length-1][3]); // Ancho del texto de validTitle4 con un margen adicional
            const lastColumnWidth = doc.getTextWidth(content.body[content.body.length-1][4]); // Ancho del texto de validTitle5 con un margen adicional

            autoTable(doc, {
                head: content.head,
                body: content.body,
                startY: startY, // Debajo de la cabecera y los títulos
                margin: { top: startY, left: marginLeftRight, right: marginLeftRight, bottom: marginBottom +10 },
                didDrawPage: function (data) {
                    pageNumber++;
                    addHeader({doc, pageNumber, headerHeight, marginLeftRight,marginTop});
            
                    const newStartY = addTitles({doc, titles, margins, headerHeight});
                        // Asegurar que la tabla comience justo después de los títulos
                    data.settings.startY = newStartY;

                    if (copia) addWatermark(doc);
                    addFooter({doc,marginLeftRight, marginBottom,nombre}); 
              
                },
                    styles: { 
                    fontSize:11,
                    lineColor: [0, 0, 0], // Color de borde (negro)
                    lineWidth: 0.5, // Grosor del borde más delgado
                },
                headStyles: {
                    fillColor: [255, 255, 255], // Fondo blanco para el encabezado
                    textColor: [0, 0, 0], // Texto negro para el encabezado
                    lineWidth: 0.5, // Grosor del borde del encabezado más delgado
                    lineColor: [0, 0, 0], // Color de borde del encabezado
                },
                bodyStyles: {
                    fillColor: [255, 255, 255], // Fondo blanco para el cuerpo
                    textColor: [0, 0, 0], // Texto negro para el cuerpo
                    lineWidth: 0.5, // Grosor del borde del cuerpo más delgado
                    lineColor: [0, 0, 0], // Color de borde del cuerpo
                },
                columnStyles: {
                    // Alinear las dos últimas columnas a la derecha
                    [0]: { halign: 'right', cellWidth: 28 }, // Primera columna
                    [content.head[0].length - 2]: { halign: 'right', cellWidth: secondLastColumnWidth }, // Penúltima columna
                    [content.head[0].length - 1]: { halign: 'right', cellWidth: lastColumnWidth }, // Última columna
                },
                pageBreak: 'auto', // Permitir que el contenido salte a nuevas páginas
                rowPageBreak:"avoid"
            });
            addTotals(doc);
        }

        const pdfBlob = doc.output('blob');
        const pdfUrl = URL.createObjectURL(pdfBlob);
        setPdfUrl(pdfUrl);
    };

    return (
        <Modal show={show} onHide={handleClose} size="lg">
            <Modal.Header closeButton>
                <Modal.Title>{title1}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {pdfUrl && (
                    <iframe src={pdfUrl} width="100%" height="500px" title="Vista previa del Recibo"></iframe>
                )}
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={handleClose}>
                    Cerrar
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default CajaDiariaPdf;
